// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ayuda — "Ayuda y soporte" view (story R12).
   Mirrors the canonical prototype (screens.css: .help-* + .contact-* +
   .set-section__*). Values match index.html; tokens are the repo bridge set. */

/* ── Content body ── (page gutters come from the .page wrapper) */
.ayuda-body {
  display: flex;
  flex-direction: column;
  gap: var(--s-10);
}

/* ── Reglas del producto (help-grid / help-card) ── */
.ayuda-rules {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

@media (max-width: 720px) {
  .ayuda-rules {
    grid-template-columns: 1fr;
  }
}

.ayuda-rule {
  background: var(--surface);
  border: 1px solid var(--border);
  padding: 18px 20px;
}

.ayuda-rule__n {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--accent);
  letter-spacing: 0.1em;
}

.ayuda-rule__t {
  font-size: var(--fs-body);
  color: var(--text);
  font-weight: 500;
  margin: 8px 0 5px;
}

.ayuda-rule__d {
  font-size: var(--fs-ui);
  color: var(--text-secondary);
  line-height: 1.55;
  margin: 0;
}

/* ── Soporte section head (set-section) ── */
.ayuda-soporte__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 18px;
}

.ayuda-soporte__title {
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-title-sm);
  letter-spacing: -0.02em;
  color: var(--text);
  margin: 4px 0 0;
}

/* ── Contact cards (contact-grid / contact-card) ── */
.ayuda-contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

@media (max-width: 720px) {
  .ayuda-contact-grid {
    grid-template-columns: 1fr;
  }
}

.ayuda-contact {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--border);
  background: var(--surface);
  padding: 14px 15px;
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.15s ease;
  /* button reset (the "Reportar" card is a <button>) */
  font: inherit;
  text-align: left;
  width: 100%;
  color: inherit;
}

.ayuda-contact:hover {
  border-color: var(--text-muted);
}

.ayuda-contact__ic {
  color: var(--accent);
  flex: none;
  display: inline-flex;
}

.ayuda-contact__t {
  font-size: var(--fs-detail);
  color: var(--text);
  font-weight: 400;
}

.ayuda-contact__d {
  font-size: var(--fs-xs);
  color: var(--text-muted);
  margin-top: 2px;
}

/* Static card (Contacto): it holds its own action links, so the card itself
   is not clickable and does not react on hover. */
.ayuda-contact--static {
  cursor: default;
}

.ayuda-contact--static:hover {
  border-color: var(--border);
}

/* Inline channel links (WhatsApp / Llamar) inside the Contacto card. */
.ayuda-contact__links {
  display: flex;
  gap: 12px;
  margin-top: 6px;
}

.ayuda-contact__links a {
  font-size: var(--fs-xs);
  color: var(--accent);
  text-decoration: none;
}

.ayuda-contact__links a:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* Note inside the "Escribir a soporte" modal. */
.ayuda-soporte-modal__note {
  font-size: var(--fs-meta);
  color: var(--text-muted);
  margin: 12px 0 0;
}
/* por qué el mensaje no se puede enviar todavía, junto al campo */
.ayuda-soporte-modal__err {
  font-size: var(--fs-meta);
  color: var(--danger);
  margin: 6px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ayuda/Ayuda.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,mCAAmC;EACnC,qDAAqD;EACrD,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;kDACkD;AAClD;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;AACA,kEAAkE;AAClE;EACE,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":["/* Ayuda — \"Ayuda y soporte\" view (story R12).\n   Mirrors the canonical prototype (screens.css: .help-* + .contact-* +\n   .set-section__*). Values match index.html; tokens are the repo bridge set. */\n\n/* ── Content body ── (page gutters come from the .page wrapper) */\n.ayuda-body {\n  display: flex;\n  flex-direction: column;\n  gap: var(--s-10);\n}\n\n/* ── Reglas del producto (help-grid / help-card) ── */\n.ayuda-rules {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 720px) {\n  .ayuda-rules {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ayuda-rule {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  padding: 18px 20px;\n}\n\n.ayuda-rule__n {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--accent);\n  letter-spacing: 0.1em;\n}\n\n.ayuda-rule__t {\n  font-size: var(--fs-body);\n  color: var(--text);\n  font-weight: 500;\n  margin: 8px 0 5px;\n}\n\n.ayuda-rule__d {\n  font-size: var(--fs-ui);\n  color: var(--text-secondary);\n  line-height: 1.55;\n  margin: 0;\n}\n\n/* ── Soporte section head (set-section) ── */\n.ayuda-soporte__head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 18px;\n}\n\n.ayuda-soporte__title {\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-title-sm);\n  letter-spacing: -0.02em;\n  color: var(--text);\n  margin: 4px 0 0;\n}\n\n/* ── Contact cards (contact-grid / contact-card) ── */\n.ayuda-contact-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 720px) {\n  .ayuda-contact-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ayuda-contact {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  padding: 14px 15px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n  /* button reset (the \"Reportar\" card is a <button>) */\n  font: inherit;\n  text-align: left;\n  width: 100%;\n  color: inherit;\n}\n\n.ayuda-contact:hover {\n  border-color: var(--text-muted);\n}\n\n.ayuda-contact__ic {\n  color: var(--accent);\n  flex: none;\n  display: inline-flex;\n}\n\n.ayuda-contact__t {\n  font-size: var(--fs-detail);\n  color: var(--text);\n  font-weight: 400;\n}\n\n.ayuda-contact__d {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n/* Static card (Contacto): it holds its own action links, so the card itself\n   is not clickable and does not react on hover. */\n.ayuda-contact--static {\n  cursor: default;\n}\n\n.ayuda-contact--static:hover {\n  border-color: var(--border);\n}\n\n/* Inline channel links (WhatsApp / Llamar) inside the Contacto card. */\n.ayuda-contact__links {\n  display: flex;\n  gap: 12px;\n  margin-top: 6px;\n}\n\n.ayuda-contact__links a {\n  font-size: var(--fs-xs);\n  color: var(--accent);\n  text-decoration: none;\n}\n\n.ayuda-contact__links a:hover {\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n/* Note inside the \"Escribir a soporte\" modal. */\n.ayuda-soporte-modal__note {\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n  margin: 12px 0 0;\n}\n/* por qué el mensaje no se puede enviar todavía, junto al campo */\n.ayuda-soporte-modal__err {\n  font-size: var(--fs-meta);\n  color: var(--danger);\n  margin: 6px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
